import { Box, Button, Pagination, Stack, Typography } from "@mui/material";
import PermissionsGate from "../../privateRoute/permissionsGate";
import { PLATFORM_PERMISSIONS } from "../../../shared/models/abacConfig";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import CustomSpinner from "../../../shared/components/customSpinner/customSpinner";
import FacilityBox from "./FacilityBox";

type Props = {
  handleUpdate: (user: any) => void;
  handleAdd: () => void;
  facilities: any[];
  pageNumber: number;
  pageLimit: number;
  handlePageChange: (...a: any) => void;
};
export const FacilityList = ({
  handleAdd,
  handleUpdate,
  facilities,
  pageNumber,
  pageLimit,
  handlePageChange
}: Props) => {
  // console.log(facilities)
  const facilityStoreState = useSelector((state: RootState) => state.facility);
  return (
    <>
      {facilityStoreState?.loading ? (
        <CustomSpinner size={"2rem"} />
      ) : (
        <>
          <Box className="facilityBox" sx={{ boxShadow: facilities?.length > 0 ? "0px 10px 60px 0px #E2ECF980" : "", border: facilities?.length > 0 ? "1px solid #EEEEEE" : "" }}>
            {facilities?.length > 0 ? (
              facilities?.map((facility, index) => {
                return (
                  <FacilityBox
                    handleUpdate={handleUpdate}
                    facility={facility}
                    key={facility?._id}
                  />
                );
              })
            ) : (
              <Typography>No Store found</Typography>
            )}
            <Stack direction={{ xs: "column", md: "row" }}>
              <Box
                className="paginationFacility"
                display={"flex"}
                sx={{ width: { xs: "100%", md: "50%" }, justifyContent: { xs: "center", md: "flex-start" } }}
              >
                <Typography
                  variant="body1"
                  textAlign="center"
                  marginY="auto"
                  marginLeft={2}
                >
                  Showing data {pageLimit * (pageNumber - 1) + 1} to{" "}
                  {pageLimit * pageNumber > facilities?.length
                    ? facilities?.length
                    : pageLimit * pageNumber}{" "}
                  from {facilities?.length}
                </Typography>
              </Box>
              <Box
                display={"flex"}
                sx={{ justifyContent: { xs: "center", md: "flex-end" }, width: { xs: "100%", md: "50%" } }}
              >
                <Pagination
                  sx={{
                    padding: 4,
                  }}
                  count={
                    facilities
                      ? facilities?.length % pageLimit == 0
                        ? facilities?.length / pageLimit
                        : Math.floor(facilities?.length / pageLimit) + 1
                      : 1
                  }
                  shape="rounded"
                  page={pageNumber}
                  onChange={handlePageChange}
                />
              </Box>
            </Stack>
          </Box>
          <PermissionsGate permissions={[PLATFORM_PERMISSIONS.FACILITY_CREATE, PLATFORM_PERMISSIONS.FACILITY_ADMIN]}>
            <Button
              variant="contained"
              className="addFacilityBtn"
              onClick={handleAdd}
            >
              Add Store
            </Button>
          </PermissionsGate>
        </>
      )}
    </>
  );
};
